// import React, { useState, useEffect, useMemo } from "react";
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
// import "../css/customCalendar.css";
// import { FaPlus, FaTrash, FaSave, FaCalendarAlt, FaClock, FaChevronDown, FaChevronUp } from "react-icons/fa";
// import { MdErrorOutline, MdInfoOutline } from "react-icons/md";
// import { useLanguage } from "../components/LanguajeContext";
// import translations from "../utils/available.translate";

// export default function Available() {
//   const [selectedService, setSelectedService] = useState("");
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [hourStart, setHourStart] = useState("");
//   const [hourEnd, setHourEnd] = useState("");
//   const [availabilities, setAvailabilities] = useState([]);
//   const [savedAvailabilities, setSavedAvailabilities] = useState([]);
//   const [services, setServices] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [errorMsg, setErrorMsg] = useState("");
//   const [expandedDates, setExpandedDates] = useState({});

//   const id_operator = localStorage.getItem("id_operator");
//   const token = localStorage.getItem("token");

//   const { language } = useLanguage() || { language: 'es' };
//   const t = translations[language] || translations.es;

//   const todayMidnight = useMemo(() => {
//     const d = new Date();
//     d.setHours(0, 0, 0, 0);
//     return d;
//   }, []);

//   const formatDateYYYYMMDD = (date) => {
//     const y = date.getFullYear();
//     const m = `${date.getMonth() + 1}`.padStart(2, "0");
//     const d = `${date.getDate()}`.padStart(2, "0");
//     return `${y}-${m}-${d}`;
//   };

//   const toMinutes = (hhmm) => {
//     const [h, m] = hhmm.split(":").map(Number);
//     return h * 60 + m;
//   };

//   const rangesOverlap = (aStart, aEnd, bStart, bEnd) => {
//     const as = toMinutes(aStart);
//     const ae = toMinutes(aEnd);
//     const bs = toMinutes(bStart);
//     const be = toMinutes(bEnd);
//     return as < be && bs < ae;
//   };

//   // Agrupar disponibilidades por fecha
//   const groupedAvailabilities = useMemo(() => {
//     const grouped = {};
//     savedAvailabilities.forEach(avail => {
//       if (!grouped[avail.date_service]) {
//         grouped[avail.date_service] = [];
//       }
//       grouped[avail.date_service].push(avail);
//     });
//     return grouped;
//   }, [savedAvailabilities]);

//   // Obtener fechas con disponibilidades
//   const datesWithAvailabilities = useMemo(() => {
//     return Object.keys(groupedAvailabilities);
//   }, [groupedAvailabilities]);

//   // Función para alternar la expansión de una fecha
//   const toggleDateExpansion = (date) => {
//     setExpandedDates(prev => ({
//       ...prev,
//       [date]: !prev[date]
//     }));
//   };

//   // --- cargar servicios ---
//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/service/${id_operator}`, {
//           //headers: { Authorization: `Bearer ${token}` },
//           credentials:"include"
//         });
//         const data = await response.json();
//         if (response.ok) {
//           setServices(data.message || []);
//         } else {
//           console.error("Error al cargar servicios:", data.error);
//         }
//       } catch (error) {
//         console.error("Error en fetch:", error);
//       }
//     };
//     if (id_operator) fetchServices();
//   }, [id_operator]);

//   // --- cargar disponibilidades guardadas ---
//   const fetchAvailabilities = async () => {
//     if (!selectedService) return;
//     setLoading(true);
//     setErrorMsg("");

//     try {
//       const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/available/${selectedService}`, {
        
//        // headers: { Authorization: `Bearer ${token}` },
//        credentials:"include"
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSavedAvailabilities(Array.isArray(data) ? data : data?.message || []);
//       } else {
//         console.error("Error al cargar disponibilidades:", data.error);
//         setErrorMsg(data.error || t.serverErr);
//       }
//     } catch (error) {
//       console.error("Error en fetch:", error);
//       setErrorMsg(t.networkErr);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (selectedService ) {
//       fetchAvailabilities();
//       setExpandedDates({});
//     } else {
//       setSavedAvailabilities([]);
//     }
//   }, [selectedService]);

//   // --- calendario: deshabilitar días pasados y marcar días con disponibilidades ---
//   const tileDisabled = ({ date, view }) => {
//     if (view !== "month") return false;
//     const d = new Date(date);
//     d.setHours(0, 0, 0, 0);
//     return d < todayMidnight;
//   };

//   // Función para personalizar el contenido de los días
//   const tileContent = ({ date, view }) => {
//     if (view !== "month") return null;
    
//     const dateStr = formatDateYYYYMMDD(date);
//     const hasAvailabilities = datesWithAvailabilities.includes(dateStr);
    
//     if (hasAvailabilities) {
//       return (
//         <div className="absolute bottom-1 right-1 w-2 h-2 bg-green-400 rounded-full"></div>
//       );
//     }
    
//     return null;
//   };

//   // Función para personalizar las clases de los días
//   const tileClassName = ({ date, view }) => {
//     if (view !== "month") return null;
    
//     const dateStr = formatDateYYYYMMDD(date);
//     const classes = [];
    
//     // Días pasados
//     const d = new Date(date);
//     d.setHours(0, 0, 0, 0);
//     if (d < todayMidnight) {
//       classes.push("disabled-day");
//     }
    
//     // Días con disponibilidades
//     if (datesWithAvailabilities.includes(dateStr)) {
//       classes.push("has-availability");
//     }
    
//     return classes.join(" ");
//   };

//   // --- agregar disponibilidad ---
//   const handleAddAvailability = () => {
//     setErrorMsg("");

//     if (!selectedService) {
//       alert(t.noServiceErr);
//       return;
//     }
//     if (!selectedDate || !hourStart || !hourEnd) {
//       alert(t.completeFields);
//       return;
//     }

//     const selectedMidnight = new Date(selectedDate);
//     selectedMidnight.setHours(0, 0, 0, 0);
//     if (selectedMidnight < todayMidnight) {
//       alert(t.pastDateErr);
//       return;
//     }

//     if (!(toMinutes(hourEnd) > toMinutes(hourStart))) {
//       alert(t.timeOrderErr);
//       return;
//     }

//     const date_service = formatDateYYYYMMDD(selectedDate);
//     const newEntry = {
//       id_service: selectedService,
//       date_service,
//       hour_start: hourStart,
//       hour_end: hourEnd,
//     };

//     const isDuplicatePending = availabilities.some(
//       (e) =>
//         e.date_service === newEntry.date_service &&
//         e.hour_start === newEntry.hour_start &&
//         e.hour_end === newEntry.hour_end
//     );
//     if (isDuplicatePending) {
//       alert(t.duplicateErr);
//       return;
//     }

//     const isDuplicateSaved = savedAvailabilities.some(
//       (e) =>
//         e.date_service === newEntry.date_service &&
//         e.hour_start === newEntry.hour_start &&
//         e.hour_end === newEntry.hour_end
//     );
//     if (isDuplicateSaved) {
//       alert(t.duplicateErr);
//       return;
//     }

//     const overlapPending = availabilities.some(
//       (e) => e.date_service === newEntry.date_service && rangesOverlap(e.hour_start, e.hour_end, newEntry.hour_start, newEntry.hour_end)
//     );
//     if (overlapPending) {
//       alert(t.overlapErr);
//       return;
//     }

//     const overlapSaved = savedAvailabilities.some(
//       (e) => e.date_service === newEntry.date_service && rangesOverlap(e.hour_start, e.hour_end, newEntry.hour_start, newEntry.hour_end)
//     );
//     if (overlapSaved) {
//       alert(t.overlapErr);
//       return;
//     }

//     setAvailabilities((prev) => [...prev, newEntry]);
//     setHourStart("");
//     setHourEnd("");
//   };

//   const handleRemove = (index) => {
//     setAvailabilities((prev) => prev.filter((_, i) => i !== index));
//   };

//   const handleSave = async () => {
//     setErrorMsg("");

//     if (!selectedService || availabilities.length === 0) {
//       alert(t.completeFields);
//       return;
//     }

//     try {
//       const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/available/${selectedService}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           //Authorization: `Bearer ${token}`,
//         },
//         credentials:"include",
//         body: JSON.stringify({ availabilities }),
//       });

//       const data = await response.json();

//       if (response.ok) {
//         alert(t.savedOk);
//         setAvailabilities([]);
//         setSelectedDate(null);
//         await fetchAvailabilities();
//       } else {
//         const details = Array.isArray(data?.details) ? data.details : null;
//         let msg = data?.error || t.serverErr;
//         if (details && details.length) {
//           msg += `\n\n${t.detailsTitle}:\n` + details.map((d) => `• idx ${d.index}: ${d.error}`).join("\n");
//         }
//         setErrorMsg(msg);
//         alert(msg);
//       }
//     } catch (error) {
//       console.error("Error de red:", error);
//       setErrorMsg(t.networkErr);
//       alert(t.networkErr);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm(t.deleteConfirm)) return;

//     try {
//       const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/available/${id}`, {
//         method: "DELETE",
//         //headers: {
//           //Authorization: `Bearer ${token}`,
//         //},
//         credentials:"include"
//       });

//       const data = await response.json();

//       if (response.ok) {
//         alert(t.deleteSuccess);
//         await fetchAvailabilities();
//       } else {
//         if(response.status==409){
//           if(data.error.code=="SERVICE_BOOKED"){
//             setErrorMsg(t.errorbookingactive)
//           }
//           if(data.error.code=="SERVICE_LOCKED"){
//             setErrorMsg(t.errorbookingproccess)
//           }
          
//         }
//         else{
//         setErrorMsg(data?.error || t.serverErr);
//         alert(data?.error || t.serverErr);
//         }
//       }
//     } catch (error) {
//       console.error("Error de red:", error);
//       setErrorMsg(t.networkErr);
//       alert(t.networkErr);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-[#102B3F] text-white p-6">
//       <div className="container mx-auto max-w-6xl">
//         {/* Header */}
//         <header className="mb-8">
//           <h1 className="text-3xl font-bold text-green-300">{t.title}</h1>
//           <p className="text-gray-300 mt-1">{t.instructions}</p>
//         </header>

//         {/* Error Message */}
//         {errorMsg && (
//           <div className="mb-6 p-4 rounded-xl bg-red-500/80 text-white font-medium shadow-md border border-red-400 flex items-start gap-3">
//             <MdErrorOutline className="text-xl mt-0.5 flex-shrink-0" />
//             <div className="whitespace-pre-wrap">{errorMsg}</div>
//           </div>
//         )}

//         {/* Main Content */}
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//           {/* Left Column - Service and Calendar */}
//           <div className="lg:col-span-1 space-y-6">
//             {/* Service Selection */}
//             <div className="bg-[#2D4A5E] rounded-2xl shadow-lg p-5 border border-[#335066]">
//               <label className="block text-sm font-medium text-gray-200 mb-2">
//                 {t.selectService}
//               </label>
//               <select
//                 value={selectedService}
//                 onChange={(e) => {
//                   setSelectedService(e.target.value);
//                   setAvailabilities([]);
//                   setSelectedDate(null);
//                 }}
//                 className="w-full p-3 rounded-xl border border-[#335066] bg-[#1B3A4B] text-white focus:ring-2 focus:ring-green-300 focus:border-green-300"
//               >
//                 <option value="">{t.selectPlaceholder}</option>
//                 {services.map((service) => (
//                   <option key={service.id_service} value={service.id_service}>
//                     {service.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Calendar */}
//             <div className="bg-[#2D4A5E] rounded-2xl shadow-lg overflow-hidden border border-[#335066]">
//               <div className="p-5">
//                 <div className="flex items-center gap-2 text-gray-200 mb-4">
//                   <FaCalendarAlt />
//                   <span className="font-medium">{t.calendar}</span>
//                 </div>
//                 <Calendar
//                   onClickDay={setSelectedDate}
//                   calendarType="gregory"
//                   className="border-0 bg-[#2D4A5E] text-white"
//                   tileDisabled={tileDisabled}
//                   tileContent={tileContent}
//                   tileClassName={tileClassName}
//                   value={selectedDate}
//                 />
//                 {selectedDate && (
//                   <div className="mt-4 p-3 bg-[#1B3A4B] rounded-xl flex items-center gap-2 border border-[#335066]">
//                     <MdInfoOutline className="text-green-300" />
//                     <span className="text-gray-200">
//                       {t.selectedDay}: {selectedDate.toLocaleDateString(language === "es" ? "es-ES" : "en-US")}
//                     </span>
//                   </div>
//                 )}
//                 <div className="mt-4 text-sm text-gray-300">
//                   <div className="flex items-center gap-2 mb-1">
//                     <div className="w-3 h-3 bg-green-400 rounded-full"></div>
//                     <span>{t.daysWithAvailabilities}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Column - Time Management */}
//           <div className="lg:col-span-2 space-y-6">
//             {/* Add Availability Section */}
//             <div className="bg-[#2D4A5E] rounded-2xl shadow-lg p-5 border border-[#335066]">
//               <h2 className="text-xl font-semibold mb-4 flex items-center gap-2 text-green-300">
//                 <FaPlus />
//                 {t.addNewAvailability}
//               </h2>

//               <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-200 mb-2">
//                     {t.startTime}
//                   </label>
//                   <input
//                     type="time"
//                     value={hourStart}
//                     onChange={(e) => setHourStart(e.target.value)}
//                     className="w-full p-3 rounded-xl border border-[#335066] bg-[#1B3A4B] text-white focus:ring-2 focus:ring-green-300 focus:border-green-300"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-200 mb-2">
//                     {t.endTime}
//                   </label>
//                   <input
//                     type="time"
//                     value={hourEnd}
//                     onChange={(e) => setHourEnd(e.target.value)}
//                     className="w-full p-3 rounded-xl border border-[#335066] bg-[#1B3A4B] text-white focus:ring-2 focus:ring-green-300 focus:border-green-300"
//                   />
//                 </div>
//                 <div className="flex items-end gap-2">
//                   <button
//                     onClick={handleAddAvailability}
//                     disabled={!selectedDate || !hourStart || !hourEnd}
//                     className="w-full bg-green-400 hover:bg-green-300 text-black font-medium py-3 px-4 rounded-xl shadow-md transition flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
//                   >
//                     <FaPlus />
//                     {t.add}
//                   </button>
//                 </div>
//               </div>

//               {availabilities.length > 0 && (
//                 <div className="mt-6">
//                   <h3 className="text-lg font-medium mb-3 flex items-center gap-2 text-green-300">
//                     <FaClock />
//                     {t.pending}
//                   </h3>
//                   <div className="overflow-x-auto">
//                     <table className="min-w-full divide-y divide-[#335066]">
//                       <thead className="bg-[#1B3A4B]">
//                         <tr>
//                           <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
//                             {t.date}
//                           </th>
//                           <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
//                             {t.timeRange}
//                           </th>
//                           <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
//                             {t.actions}
//                           </th>
//                         </tr>
//                       </thead>
//                       <tbody className="bg-[#2D4A5E] divide-y divide-[#335066]">
//                         {availabilities.map((entry, idx) => (
//                           <tr key={`${entry.date_service}-${entry.hour_start}-${entry.hour_end}-${idx}`}>
//                             <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-200">
//                               {entry.date_service}
//                             </td>
//                             <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-200">
//                               {entry.hour_start} - {entry.hour_end}
//                             </td>
//                             <td className="px-4 py-3 whitespace-nowrap text-sm">
//                               <button
//                                 onClick={() => handleRemove(idx)}
//                                 className="text-red-400 hover:text-red-300 font-medium flex items-center gap-1"
//                               >
//                                 <FaTrash />
//                                 {t.remove}
//                               </button>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Save Button */}
//             {availabilities.length > 0 && (
//               <div className="flex justify-end">
//                 <button
//                   onClick={handleSave}
//                   className="bg-green-400 hover:bg-green-300 text-black font-medium py-3 px-6 rounded-xl shadow-md transition flex items-center gap-2"
//                 >
//                   <FaSave />
//                   {t.save}
//                 </button>
//               </div>
//             )}

//             {/* Saved Availabilities */}
//             <div className="bg-[#2D4A5E] rounded-2xl shadow-lg p-5 border border-[#335066]">
//               <div className="flex items-center justify-between mb-4">
//                 <h2 className="text-xl font-semibold flex items-center gap-2 text-green-300">
//                   <FaClock />
//                   {t.currentAvailability}
//                 </h2>
//                 {loading && (
//                   <span className="text-sm text-gray-400 animate-pulse">
//                     {t.reloadSaved}
//                   </span>
//                 )}
//               </div>

//               {savedAvailabilities.length > 0 ? (
//                 <div className="space-y-3">
//                   {Object.entries(groupedAvailabilities).map(([date, availabilitiesForDate]) => (
//                     <div key={date} className="bg-[#1B3A4B] rounded-xl border border-[#335066] overflow-hidden">
//                       <button
//                         onClick={() => toggleDateExpansion(date)}
//                         className="w-full p-4 flex justify-between items-center text-left hover:bg-[#234357] transition-colors"
//                       >
//                         <div className="flex items-center gap-3">
//                           <span className="font-medium text-gray-200">{date}</span>
//                           <span className="text-xs bg-green-400 text-black px-2 py-1 rounded-full">
//                             {availabilitiesForDate.length} {t.timeSlots}
//                           </span>
//                         </div>
//                         {expandedDates[date] ? <FaChevronUp /> : <FaChevronDown />}
//                       </button>
                      
//                       {expandedDates[date] && (
//                         <div className="border-t border-[#335066]">
//                           <table className="w-full">
//                             <thead>
//                               <tr className="bg-[#234357]">
//                                 <th className="px-4 py-2 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
//                                   {t.timeRange}
//                                 </th>
//                                 <th className="px-4 py-2 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
//                                   {t.actions}
//                                 </th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {availabilitiesForDate.map((item) => (
//                                 <tr key={item.id_available} className="border-b border-[#335066] last:border-b-0">
//                                   <td className="px-4 py-3 text-sm text-gray-200">
//                                     {item.hour_start} - {item.hour_end}
//                                   </td>
//                                   <td className="px-4 py-3 space-x-2">
//                                     <button
//                                       onClick={() => handleDelete(item.id_available)}
//                                       className="text-red-400 hover:text-red-300 font-medium flex items-center gap-1 text-sm"
//                                     >
//                                       <FaTrash />
//                                       {t.remove}
//                                     </button>
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <div className="text-center py-8 text-gray-400">
//                   {t.noAvailabilities}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect, useMemo } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../css/customCalendar.css";
import { FaPlus, FaTrash, FaSave, FaCalendarAlt, FaClock, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { MdErrorOutline, MdInfoOutline } from "react-icons/md";
import { useLanguage } from "../components/LanguajeContext";
import translations from "../utils/available.translate";

export default function Available() {
  const [selectedService, setSelectedService] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [hourStart, setHourStart] = useState("");
  const [hourEnd, setHourEnd] = useState("");
  const [availabilities, setAvailabilities] = useState([]);
  const [savedAvailabilities, setSavedAvailabilities] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [expandedDates, setExpandedDates] = useState({});

  const id_operator = localStorage.getItem("id_operator");
  const token = localStorage.getItem("token");

  const { language } = useLanguage() || { language: 'es' };
  const t = translations[language] || translations.es;

  const todayMidnight = useMemo(() => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }, []);

  const formatDateYYYYMMDD = (date) => {
    const y = date.getFullYear();
    const m = `${date.getMonth() + 1}`.padStart(2, "0");
    const d = `${date.getDate()}`.padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  const toMinutes = (hhmm) => {
    const [h, m] = hhmm.split(":").map(Number);
    return h * 60 + m;
  };

  const rangesOverlap = (aStart, aEnd, bStart, bEnd) => {
    const as = toMinutes(aStart);
    const ae = toMinutes(aEnd);
    const bs = toMinutes(bStart);
    const be = toMinutes(bEnd);
    return as < be && bs < ae;
  };

  // Agrupar disponibilidades por fecha
  const groupedAvailabilities = useMemo(() => {
    const grouped = {};
    savedAvailabilities.forEach(avail => {
      if (!grouped[avail.date_service]) {
        grouped[avail.date_service] = [];
      }
      grouped[avail.date_service].push(avail);
    });
    return grouped;
  }, [savedAvailabilities]);

  // Obtener fechas con disponibilidades
  const datesWithAvailabilities = useMemo(() => {
    return Object.keys(groupedAvailabilities);
  }, [groupedAvailabilities]);

  // Función para alternar la expansión de una fecha
  const toggleDateExpansion = (date) => {
    setExpandedDates(prev => ({
      ...prev,
      [date]: !prev[date]
    }));
  };

  // --- cargar servicios ---
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/service/${id_operator}`, {
          //headers: { Authorization: `Bearer ${token}` },
          credentials:"include"
        });
        const data = await response.json();
        if (response.ok) {
          setServices(data.message || []);
        } else {
          console.error("Error al cargar servicios:", data.error);
        }
      } catch (error) {
        console.error("Error en fetch:", error);
      }
    };
    if (id_operator) fetchServices();
  }, [id_operator]);

  // --- cargar disponibilidades guardadas ---
  const fetchAvailabilities = async () => {
    if (!selectedService) return;
    setLoading(true);
    setErrorMsg("");

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/available/${selectedService}`, {
        
       // headers: { Authorization: `Bearer ${token}` },
       credentials:"include"
      });
      const data = await response.json();
      if (response.ok) {
        setSavedAvailabilities(Array.isArray(data) ? data : data?.message || []);
      } else {
        console.error("Error al cargar disponibilidades:", data.error);
        setErrorMsg(data.error || t.serverErr);
      }
    } catch (error) {
      console.error("Error en fetch:", error);
      setErrorMsg(t.networkErr);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedService ) {
      fetchAvailabilities();
      setExpandedDates({});
    } else {
      setSavedAvailabilities([]);
    }
  }, [selectedService]);

  // --- calendario: deshabilitar días pasados y marcar días con disponibilidades ---
  const tileDisabled = ({ date, view }) => {
    if (view !== "month") return false;
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d < todayMidnight;
  };

  // Función para personalizar el contenido de los días
  const tileContent = ({ date, view }) => {
    if (view !== "month") return null;
    
    const dateStr = formatDateYYYYMMDD(date);
    const hasAvailabilities = datesWithAvailabilities.includes(dateStr);
    
    if (hasAvailabilities) {
      return (
        <div className="absolute bottom-1 right-1 w-2 h-2 bg-green-400 rounded-full"></div>
      );
    }
    
    return null;
  };

  // Función para personalizar las clases de los días
  const tileClassName = ({ date, view }) => {
    if (view !== "month") return null;
    
    const dateStr = formatDateYYYYMMDD(date);
    const classes = [];
    
    // Días pasados
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    if (d < todayMidnight) {
      classes.push("disabled-day");
    }
    
    // Días con disponibilidades
    if (datesWithAvailabilities.includes(dateStr)) {
      classes.push("has-availability");
    }
    
    return classes.join(" ");
  };

  // --- agregar disponibilidad ---
  const handleAddAvailability = () => {
    setErrorMsg("");

    if (!selectedService) {
      alert(t.noServiceErr);
      return;
    }
    if (!selectedDate || !hourStart || !hourEnd) {
      alert(t.completeFields);
      return;
    }

    const selectedMidnight = new Date(selectedDate);
    selectedMidnight.setHours(0, 0, 0, 0);
    if (selectedMidnight < todayMidnight) {
      alert(t.pastDateErr);
      return;
    }

    if (!(toMinutes(hourEnd) > toMinutes(hourStart))) {
      alert(t.timeOrderErr);
      return;
    }

    const date_service = formatDateYYYYMMDD(selectedDate);
    const newEntry = {
      id_service: selectedService,
      date_service,
      hour_start: hourStart,
      hour_end: hourEnd,
    };

    const isDuplicatePending = availabilities.some(
      (e) =>
        e.date_service === newEntry.date_service &&
        e.hour_start === newEntry.hour_start &&
        e.hour_end === newEntry.hour_end
    );
    if (isDuplicatePending) {
      alert(t.duplicateErr);
      return;
    }

    const isDuplicateSaved = savedAvailabilities.some(
      (e) =>
        e.date_service === newEntry.date_service &&
        e.hour_start === newEntry.hour_start &&
        e.hour_end === newEntry.hour_end
    );
    if (isDuplicateSaved) {
      alert(t.duplicateErr);
      return;
    }

    const overlapPending = availabilities.some(
      (e) => e.date_service === newEntry.date_service && rangesOverlap(e.hour_start, e.hour_end, newEntry.hour_start, newEntry.hour_end)
    );
    if (overlapPending) {
      alert(t.overlapErr);
      return;
    }

    const overlapSaved = savedAvailabilities.some(
      (e) => e.date_service === newEntry.date_service && rangesOverlap(e.hour_start, e.hour_end, newEntry.hour_start, newEntry.hour_end)
    );
    if (overlapSaved) {
      alert(t.overlapErr);
      return;
    }

    setAvailabilities((prev) => [...prev, newEntry]);
    setHourStart("");
    setHourEnd("");
  };

  const handleRemove = (index) => {
    setAvailabilities((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSave = async () => {
    setErrorMsg("");

    if (!selectedService || availabilities.length === 0) {
      alert(t.completeFields);
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/available/${selectedService}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          //Authorization: `Bearer ${token}`,
        },
        credentials:"include",
        body: JSON.stringify({ availabilities }),
      });

      const data = await response.json();

      if (response.ok) {
        alert(t.savedOk);
        setAvailabilities([]);
        setSelectedDate(null);
        await fetchAvailabilities();
      } else {
        const details = Array.isArray(data?.details) ? data.details : null;
        let msg = data?.error || t.serverErr;
        if (details && details.length) {
          msg += `\n\n${t.detailsTitle}:\n` + details.map((d) => `• idx ${d.index}: ${d.error}`).join("\n");
        }
        setErrorMsg(msg);
        alert(msg);
      }
    } catch (error) {
      console.error("Error de red:", error);
      setErrorMsg(t.networkErr);
      alert(t.networkErr);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm(t.deleteConfirm)) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/available/${id}`, {
        method: "DELETE",
        //headers: {
          //Authorization: `Bearer ${token}`,
        //},
        credentials:"include"
      });

      const data = await response.json();

      if (response.ok) {
        alert(t.deleteSuccess);
        await fetchAvailabilities();
      } else {
        if(response.status==409){
          if(data.error.code=="SERVICE_BOOKED"){
            setErrorMsg(t.errorbookingactive)
          }
          if(data.error.code=="SERVICE_LOCKED"){
            setErrorMsg(t.errorbookingproccess)
          }
          
        }
        else{
        setErrorMsg(data?.error || t.serverErr);
        alert(data?.error || t.serverErr);
        }
      }
    } catch (error) {
      console.error("Error de red:", error);
      setErrorMsg(t.networkErr);
      alert(t.networkErr);
    }
  };

  return (
    <div className="min-h-screen bg-[#102B3F] text-white p-4 sm:p-6">
      <div className="container mx-auto max-w-6xl">
        {/* Header */}
        <header className="mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-green-300">{t.title}</h1>
          <p className="text-gray-300 mt-1 text-sm sm:text-base">{t.instructions}</p>
        </header>

        {/* Error Message */}
        {errorMsg && (
          <div className="mb-4 sm:mb-6 p-3 sm:p-4 rounded-xl bg-red-500/80 text-white font-medium shadow-md border border-red-400 flex items-start gap-3 text-sm sm:text-base">
            <MdErrorOutline className="text-xl mt-0.5 flex-shrink-0" />
            <div className="whitespace-pre-wrap break-words">{errorMsg}</div>
          </div>
        )}

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6">
          {/* Left Column - Service and Calendar */}
          <div className="lg:col-span-1 space-y-4 sm:space-y-6">
            {/* Service Selection */}
            <div className="bg-[#2D4A5E] rounded-2xl shadow-lg p-4 sm:p-5 border border-[#335066]">
              <label className="block text-sm font-medium text-gray-200 mb-2">
                {t.selectService}
              </label>
              <select
                value={selectedService}
                onChange={(e) => {
                  setSelectedService(e.target.value);
                  setAvailabilities([]);
                  setSelectedDate(null);
                }}
                className="w-full p-3 rounded-xl border border-[#335066] bg-[#1B3A4B] text-white focus:ring-2 focus:ring-green-300 focus:border-green-300 text-sm sm:text-base"
              >
                <option value="">{t.selectPlaceholder}</option>
                {services.map((service) => (
                  <option key={service.id_service} value={service.id_service}>
                    {service.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Calendar */}
            <div className="bg-[#2D4A5E] rounded-2xl shadow-lg overflow-hidden border border-[#335066]">
              <div className="p-3 sm:p-5">
                <div className="flex items-center gap-2 text-gray-200 mb-3 sm:mb-4">
                  <FaCalendarAlt className="text-sm sm:text-base" />
                  <span className="font-medium text-sm sm:text-base">{t.calendar}</span>
                </div>
                <div className="scale-90 sm:scale-100 origin-top-left">
                  <Calendar
                    onClickDay={setSelectedDate}
                    calendarType="gregory"
                    className="border-0 bg-[#2D4A5E] text-white w-full"
                    tileDisabled={tileDisabled}
                    tileContent={tileContent}
                    tileClassName={tileClassName}
                    value={selectedDate}
                  />
                </div>
                {selectedDate && (
                  <div className="mt-3 sm:mt-4 p-3 bg-[#1B3A4B] rounded-xl flex items-center gap-2 border border-[#335066] text-sm">
                    <MdInfoOutline className="text-green-300 flex-shrink-0" />
                    <span className="text-gray-200">
                      {t.selectedDay}: {selectedDate.toLocaleDateString(language === "es" ? "es-ES" : "en-US")}
                    </span>
                  </div>
                )}
                <div className="mt-3 sm:mt-4 text-xs sm:text-sm text-gray-300">
                  <div className="flex items-center gap-2 mb-1">
                    <div className="w-2 h-2 sm:w-3 sm:h-3 bg-green-400 rounded-full"></div>
                    <span>{t.daysWithAvailabilities}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Time Management */}
          <div className="lg:col-span-2 space-y-4 sm:space-y-6">
            {/* Add Availability Section */}
            <div className="bg-[#2D4A5E] rounded-2xl shadow-lg p-4 sm:p-5 border border-[#335066]">
              <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 flex items-center gap-2 text-green-300">
                <FaPlus className="text-sm sm:text-base" />
                {t.addNewAvailability}
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 mb-3 sm:mb-4">
                <div className="sm:col-span-1">
                  <label className="block text-sm font-medium text-gray-200 mb-2">
                    {t.startTime}
                  </label>
                  <input
                    type="time"
                    value={hourStart}
                    onChange={(e) => setHourStart(e.target.value)}
                    className="w-full p-3 rounded-xl border border-[#335066] bg-[#1B3A4B] text-white focus:ring-2 focus:ring-green-300 focus:border-green-300 text-sm sm:text-base"
                  />
                </div>
                <div className="sm:col-span-1">
                  <label className="block text-sm font-medium text-gray-200 mb-2">
                    {t.endTime}
                  </label>
                  <input
                    type="time"
                    value={hourEnd}
                    onChange={(e) => setHourEnd(e.target.value)}
                    className="w-full p-3 rounded-xl border border-[#335066] bg-[#1B3A4B] text-white focus:ring-2 focus:ring-green-300 focus:border-green-300 text-sm sm:text-base"
                  />
                </div>
                <div className="sm:col-span-1 flex items-end gap-2">
                  <button
                    onClick={handleAddAvailability}
                    disabled={!selectedDate || !hourStart || !hourEnd}
                    className="w-full bg-green-400 hover:bg-green-300 text-black font-medium py-3 px-3 sm:px-4 rounded-xl shadow-md transition flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base"
                  >
                    <FaPlus className="text-xs sm:text-sm" />
                    {t.add}
                  </button>
                </div>
              </div>

              {availabilities.length > 0 && (
                <div className="mt-4 sm:mt-6">
                  <h3 className="text-base sm:text-lg font-medium mb-2 sm:mb-3 flex items-center gap-2 text-green-300">
                    <FaClock className="text-sm sm:text-base" />
                    {t.pending}
                  </h3>
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-[#335066] text-sm">
                      <thead className="bg-[#1B3A4B]">
                        <tr>
                          <th className="px-3 py-2 sm:px-4 sm:py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                            {t.date}
                          </th>
                          <th className="px-3 py-2 sm:px-4 sm:py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                            {t.timeRange}
                          </th>
                          <th className="px-3 py-2 sm:px-4 sm:py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                            {t.actions}
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-[#2D4A5E] divide-y divide-[#335066]">
                        {availabilities.map((entry, idx) => (
                          <tr key={`${entry.date_service}-${entry.hour_start}-${entry.hour_end}-${idx}`}>
                            <td className="px-3 py-2 sm:px-4 sm:py-3 whitespace-nowrap text-gray-200">
                              {entry.date_service}
                            </td>
                            <td className="px-3 py-2 sm:px-4 sm:py-3 whitespace-nowrap text-gray-200">
                              {entry.hour_start} - {entry.hour_end}
                            </td>
                            <td className="px-3 py-2 sm:px-4 sm:py-3 whitespace-nowrap">
                              <button
                                onClick={() => handleRemove(idx)}
                                className="text-red-400 hover:text-red-300 font-medium flex items-center gap-1 text-xs sm:text-sm"
                              >
                                <FaTrash className="text-xs sm:text-sm" />
                                {t.remove}
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>

            {/* Save Button */}
            {availabilities.length > 0 && (
              <div className="flex justify-end">
                <button
                  onClick={handleSave}
                  className="bg-green-400 hover:bg-green-300 text-black font-medium py-3 px-4 sm:px-6 rounded-xl shadow-md transition flex items-center gap-2 w-full sm:w-auto text-sm sm:text-base justify-center"
                >
                  <FaSave className="text-sm sm:text-base" />
                  {t.save}
                </button>
              </div>
            )}

            {/* Saved Availabilities */}
            <div className="bg-[#2D4A5E] rounded-2xl shadow-lg p-4 sm:p-5 border border-[#335066]">
              <div className="flex items-center justify-between mb-3 sm:mb-4">
                <h2 className="text-lg sm:text-xl font-semibold flex items-center gap-2 text-green-300">
                  <FaClock className="text-sm sm:text-base" />
                  {t.currentAvailability}
                </h2>
                {loading && (
                  <span className="text-xs sm:text-sm text-gray-400 animate-pulse">
                    {t.reloadSaved}
                  </span>
                )}
              </div>

              {savedAvailabilities.length > 0 ? (
                <div className="space-y-3">
                  {Object.entries(groupedAvailabilities).map(([date, availabilitiesForDate]) => (
                    <div key={date} className="bg-[#1B3A4B] rounded-xl border border-[#335066] overflow-hidden">
                      <button
                        onClick={() => toggleDateExpansion(date)}
                        className="w-full p-3 sm:p-4 flex justify-between items-center text-left hover:bg-[#234357] transition-colors"
                      >
                        <div className="flex items-center gap-2 sm:gap-3">
                          <span className="font-medium text-gray-200 text-sm sm:text-base">{date}</span>
                          <span className="text-xs bg-green-400 text-black px-2 py-1 rounded-full">
                            {availabilitiesForDate.length} {t.timeSlots}
                          </span>
                        </div>
                        {expandedDates[date] ? <FaChevronUp /> : <FaChevronDown />}
                      </button>
                      
                      {expandedDates[date] && (
                        <div className="border-t border-[#335066]">
                          <div className="overflow-x-auto">
                            <table className="w-full text-sm">
                              <thead>
                                <tr className="bg-[#234357]">
                                  <th className="px-3 py-2 sm:px-4 sm:py-2 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                                    {t.timeRange}
                                  </th>
                                  <th className="px-3 py-2 sm:px-4 sm:py-2 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                                    {t.actions}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {availabilitiesForDate.map((item) => (
                                  <tr key={item.id_available} className="border-b border-[#335066] last:border-b-0">
                                    <td className="px-3 py-2 sm:px-4 sm:py-3 text-gray-200">
                                      {item.hour_start} - {item.hour_end}
                                    </td>
                                    <td className="px-3 py-2 sm:px-4 sm:py-3 space-x-2">
                                      <button
                                        onClick={() => handleDelete(item.id_available)}
                                        className="text-red-400 hover:text-red-300 font-medium flex items-center gap-1 text-xs sm:text-sm"
                                      >
                                        <FaTrash className="text-xs sm:text-sm" />
                                        {t.remove}
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-6 sm:py-8 text-gray-400 text-sm sm:text-base">
                  {t.noAvailabilities}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}